/* ATHLO+ — Locker HUD boot sequence (ADDON, removable)
 * ==========================================================================
 * 2Advanced-style "mission console" boot for the Locker: a small mono chip
 * types status lines (SYNCING_ STRAVA.FEED · OK …) while the page hydrates,
 * plus one lime scanline sweep down the section, then everything fades and
 * removes itself. Pure decoration in PARALLEL with the real hydration — it
 * never gates or delays content, is pointer-events:none throughout, and is
 * aria-hidden (screen readers get the real content, not terminal cosplay).
 *
 * Runs only: on a page with #locker · for signed-in members (guests see a
 * sign-in card — fake sync lines would lie) · once per browser session
 * (sessionStorage) · when reduced-motion is off. Fails safe: any error or
 * missing anchor = nothing happens.
 * Removable: delete this file + its <script> line in hub-locker.liquid.
 * ========================================================================= */
(function () {
  'use strict';

  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function css() {
    if (document.getElementById('hub-locker-boot-css')) return;
    var st = document.createElement('style');
    st.id = 'hub-locker-boot-css';
    st.textContent =
      '.hub-boot{position:fixed;top:calc(76px + env(safe-area-inset-top,0px));left:50%;transform:translateX(-50%) translateY(-6px);z-index:9200;pointer-events:none;' +
        'background:color-mix(in srgb,var(--ink-900,#0B0E12) 88%,transparent);border:1px solid color-mix(in srgb,var(--lime,#B7FF00) 35%,rgba(255,255,255,.12));' +
        'border-radius:8px;padding:.5rem .8rem;min-width:248px;max-width:calc(100vw - 2rem);' +
        'font-family:var(--font-mono,monospace);font-size:.64rem;letter-spacing:.08em;text-transform:uppercase;color:var(--lime,#B7FF00);' +
        'box-shadow:0 10px 34px -12px rgba(0,0,0,.7),0 0 26px -10px rgba(183,255,0,.4);' +
        'opacity:0;transition:opacity .3s ease,transform .45s cubic-bezier(.16,1,.3,1)}' +
      '.hub-boot.is-in{opacity:1;transform:translateX(-50%) translateY(0)}' +
      '.hub-boot.is-out{opacity:0;transform:translateX(-50%) translateY(-8px)}' +
      '.hub-boot__line{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-height:1.5em;color:rgba(239,239,239,.55)}' +
      '.hub-boot__line.is-now{color:var(--lime,#B7FF00)}' +
      '.hub-boot__line.is-now::after{content:"▌";margin-left:2px;animation:hub-boot-caret .7s steps(1) infinite}' +
      '@keyframes hub-boot-caret{50%{opacity:0}}' +
      '.hub-boot__ok{color:var(--lime,#B7FF00);font-weight:700}' +
      '.hub-scanline{position:absolute;left:0;right:0;top:0;height:120px;z-index:5;pointer-events:none;' +
        'background:linear-gradient(180deg,transparent 0%,rgba(183,255,0,.045) 45%,rgba(183,255,0,.12) 50%,rgba(183,255,0,.045) 55%,transparent 100%);' +
        'animation:hub-scan 1.1s cubic-bezier(.4,0,.2,1) .35s both}' +
      '@keyframes hub-scan{from{transform:translateY(-140px)}to{transform:translateY(105vh)}}';
    document.head.appendChild(st);
  }

  var LINES = [
    'ATHLO+.OS — locker boot',
    'syncing_ strava.feed <b class="hub-boot__ok">· ok</b>',
    'loading_ season.core <b class="hub-boot__ok">· ok</b>',
    'athlete online <b class="hub-boot__ok">●</b>'
  ];

  function typeLine(el, html, done) {
    // types the text portion char-by-char, then swaps in the full html (for the OK tail)
    var text = html.replace(/<[^>]*>/g, '');
    var i = 0, t = setInterval(function () {
      i++;
      el.textContent = text.slice(0, i);
      if (i >= text.length) { clearInterval(t); el.innerHTML = html; done && done(); }
    }, 13);
  }

  function run() {
    var locker = document.getElementById('locker');
    var member = (document.body.getAttribute('data-member-id') || '').trim();
    if (!locker || !member || REDUCE) return;
    // background tabs throttle timers → the typewriter would crawl; boot on the next visible visit instead
    if (document.hidden) return;
    try { if (sessionStorage.getItem('hub:boot')) return; sessionStorage.setItem('hub:boot', '1'); } catch (e) {}

    css();

    // scanline sweep over the locker section (self-removes)
    var pos = getComputedStyle(locker).position;
    if (pos === 'static') locker.style.position = 'relative';
    var scan = document.createElement('div');
    scan.className = 'hub-scanline';
    scan.setAttribute('aria-hidden', 'true');
    locker.appendChild(scan);
    scan.addEventListener('animationend', function () { if (scan.parentNode) scan.parentNode.removeChild(scan); });

    // boot chip
    var chip = document.createElement('div');
    chip.className = 'hub-boot';
    chip.setAttribute('aria-hidden', 'true');
    document.body.appendChild(chip);
    requestAnimationFrame(function () { requestAnimationFrame(function () { chip.classList.add('is-in'); }); });

    // hard lifetime cap: whatever happens (tab hidden mid-boot, throttled timers),
    // the chip is gone by 9s — same failsafe doctrine as the page loader
    setTimeout(function () { if (chip.parentNode) chip.parentNode.removeChild(chip); }, 9000);

    var idx = 0;
    function next() {
      if (idx >= LINES.length) {
        setTimeout(function () { chip.classList.add('is-out'); }, 750);
        setTimeout(function () { if (chip.parentNode) chip.parentNode.removeChild(chip); }, 1250);
        return;
      }
      var ln = document.createElement('span');
      ln.className = 'hub-boot__line is-now';
      chip.appendChild(ln);
      var prev = chip.querySelectorAll('.hub-boot__line');
      if (prev.length > 1) prev[prev.length - 2].classList.remove('is-now');
      typeLine(ln, LINES[idx++], function () { setTimeout(next, 210); });
    }
    setTimeout(next, 300);
  }

  function init() { try { run(); } catch (e) { /* fail safe */ } }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
